import React from 'react';
import type { EntityName } from '../auth/Security';
import { H } from '../Layout';
import SavedFilterChip from './SavedFilterChip';
import SaveFilterMenu from './SaveFilterMenu';

export default ({
    entityName,
    filterName,
    hasUnsavedChanges,
    onClear,
    onSave,
    onSaveAsNew,
    savingFilter
}: {
    entityName: EntityName;
    filterName: string;
    hasUnsavedChanges: boolean;
    onClear: () => void;
    onSave: () => void;
    onSaveAsNew: () => void;
    savingFilter: boolean;
}) => {
    return (
        <H gap={1.5} sx={{ width: 'unset' }}>
            <SavedFilterChip filterName={filterName} onClear={onClear} hasUnsavedChanges={hasUnsavedChanges} />
            {hasUnsavedChanges && (
                <SaveFilterMenu
                    entityName={entityName}
                    onSave={onSave}
                    onSaveAsNew={onSaveAsNew}
                    savingFilter={savingFilter}
                />
            )}
        </H>
    );
};
